import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, from } from 'rxjs';
import { catchError, map, mergeAll } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ClientService } from '../services/client.service';
import { errors, routes } from '../utils/catalog';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private client: ClientService, private authService: AuthService) {}

  private async trySessionRefresh(): Promise<void> {
    const refreshed = await this.authService.refresh();
    if (!refreshed) this.router.navigateByUrl(routes.login.url, { replaceUrl: true });
  }

  private async updateHeaders(req: HttpRequest<any>): Promise<HttpRequest<any>> {
    const updatedHeaders = await this.client.getHeaders();
    return req.clone({
      setHeaders: updatedHeaders,
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        if (e.status === 401 && e.error.code === errors.noSession.code) {
          return from(this.trySessionRefresh()).pipe(
            map(() => from(this.updateHeaders(req))),
            mergeAll(),
            map((newReq) => next.handle(newReq)),
            mergeAll()
          );
        }
        return throwError(() => e);
      })
    );
  }
}
